import React from "react";
import { observer } from "mobx-react";
import { UserNotificationPreferenceViewStore } from "../../store";
import { UserNotificationPreferenceViewForm } from "./UserNotificationPreferenceViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type UserNotificationPreferenceViewProps = {
  userNotificationPreferenceViewStore: UserNotificationPreferenceViewStore;
};

export const UserNotificationPreferenceView: React.FC<UserNotificationPreferenceViewProps> =
  observer(({ userNotificationPreferenceViewStore }) => {
    return (
      <div>
        <UserNotificationPreferenceViewForm
          notificationTypeOptions={userNotificationPreferenceViewStore.getNotificationTypeOptions()}
          notificationType={
            userNotificationPreferenceViewStore.notificationTypeValue
          }
          inAppEnabled={userNotificationPreferenceViewStore.inAppEnabledValue}
          emailEnabled={userNotificationPreferenceViewStore.emailEnabledValue}
          emailFrequencyOptions={userNotificationPreferenceViewStore.getEmailFrequencyOptions()}
          emailFrequency={
            userNotificationPreferenceViewStore.emailFrequencyValue
          }
          onPrint={(handlePrint: () => void) =>
            userNotificationPreferenceViewStore.printUserNotificationPreference(
              handlePrint
            )
          }
          onCancel={() =>
            userNotificationPreferenceViewStore.cancelUserNotificationPreference()
          }
          onEdit={
            userNotificationPreferenceViewStore.isEditEnabled
              ? () =>
                  userNotificationPreferenceViewStore.editUserNotificationPreference()
              : undefined
          }
        />
        <ErrorDialog
          open={userNotificationPreferenceViewStore.errorDialogOpened}
          title={userNotificationPreferenceViewStore.errorTitle}
          description={userNotificationPreferenceViewStore.errorDescription}
          onClose={() => userNotificationPreferenceViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
